/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const RevokeBody = zod.looseObject({});

export type RevokeBody = zod.input<typeof RevokeBody>;
export type RevokeBodyOutput = zod.output<typeof RevokeBody>;
